import React, { useState } from "react";
import { Title, Balance, PayoutBtnContainer } from "../pages/IndividualVirtualAccount/styles";
import { Button } from "../../../components/common/Button";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";
import { ReactComponent as DropDown } from "../../../assets/icons/drop-down.svg";
import { Tooltip } from "antd";
import { Flex, TooltipWrapper } from "../../Customers/styles";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenuItem,
  UserBox,
} from "../../../components/AppShell/components/Header/style";
import { useAppSelector } from "../../../app/hooks";
import { WalletSummaryCard, WalletSummarySection, Wrapper } from "../pages/AllVirtualAccounts/style";
import { formatCurrencyCodeAmount } from "../../../utils/currency";
import CurrencyFlag from "../../Wallets/components/CurrencyFlag";
import { CURRENCIES } from "../../Wallets/utils";

type Props = {
  title: string;
  balance?: string;
  toolTip?: React.ReactElement;
  onClick?: any;
  isSettlementFlow?: boolean;
  disabled?: boolean;
  tooltipText: string;
  wallets?: any;
  baseUrlForRedirection?: string;
  disableRedirection?: boolean;
  currency?: string;
}

const AccountBalance = ({
  title,
  balance,
  isSettlementFlow,
  disabled,
  tooltipText,
  wallets,
  baseUrlForRedirection,
  disableRedirection = false,
  currency,
}: Props) => {
  const [dropdownOpen, setdDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { business } = useAppSelector((state) => state.settings);

  const redirectToCurrency = (data) => {
    if (business?.approved) {
      navigate(`/${baseUrlForRedirection}/${data?.currency?.toLowerCase()}`);
      return;
    }
  };

  const WALLET_FIELD_MAP = {
    "Virtual account balance": "holdBalance",
    "Settlement balance": "settlementBalance",
  }

  return (
    <>
      <Flex>
        <TooltipWrapper>
          <Title>{title}</Title>
          <Tooltip
            overlayClassName="input-tooltip"
            placement="right"
            title={tooltipText}
            trigger={["hover", "click"]}
            className="tool-tip"
          >
            <InfoIcon />
          </Tooltip>
        </TooltipWrapper>

        {isSettlementFlow && (
          <Button
            data-testid="request-payout-button"
            theme="primary"
            width="150px"
            height="40px"
            disabled={disabled}
            onClick={() => setdDropdownOpen(true)}
          >
            <PayoutBtnContainer>
              <span>Request payout</span>
              <DropDown />
            </PayoutBtnContainer>

            <UserBox isOpen={dropdownOpen}>
              <div className="dropdown dropdown-space">
                <DropdownMenuItem
                  onClick={() => navigate(`/settlements/fund/settlement/${currency}`)}
                >
                  <span>To my wallet</span>
                </DropdownMenuItem>

                <DropdownMenuItem
                  onClick={() => navigate(`/settlements/fund/payout/${currency}`)}
                >
                  <span>To bank account</span>
                </DropdownMenuItem>
              </div>
            </UserBox>
          </Button>
        )}
      </Flex>

      {!wallets && <Balance>{balance}</Balance>}

      <WalletSummarySection>
        {wallets?.map(
          (wallet) =>
          (
            <WalletSummaryCard
              key={wallet.currency}
              onClick={() => { !disableRedirection && redirectToCurrency(wallet) }}
              currency={wallet?.currency}
              disabled={disableRedirection}
            >
              <Wrapper>
                <p>
                  <CurrencyFlag currency={wallet.currency} />
                  <span>{CURRENCIES[wallet.currency].name}</span>
                </p>
              </Wrapper>
              <h4 className="amount">
                <span />
                {formatCurrencyCodeAmount(
                  wallet?.currency,
                  wallet?.[WALLET_FIELD_MAP[title]] ?? 0
                )}
              </h4>
            </WalletSummaryCard>
          )
        )}
      </WalletSummarySection>
      {dropdownOpen && (
        <div className="overlay" onClick={() => setdDropdownOpen(false)} />
      )}
    </>
  );
};

export default AccountBalance;
